export const avatarStyles = ({ palette }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 20,
  height: 20,
  borderRadius: '50%',
  backgroundColor: palette.primary.main,
  color: palette.primary.contrastText,
});

export const initialsStyles = {
  color: 'inherit',
};

export const systemAvatarStyles = ({ palette }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 20,
  height: 20,
  borderRadius: '50%',
  backgroundColor: palette.action.disabledBackground,
  color: palette.text.secondary,
});
